import * as React from 'react';
import { useSelector } from 'react-redux';
import { Escrow } from '../../components/Escrow';
import { isEscrowSelector } from '../../selectors/newbuilding';
import { EscrowDescriptionContainer } from '../EscrowDescription';
import { EscrowHousesContainer } from '../EscrowHouses';

export const EscrowContainer = () => {
  const isEscrow = useSelector(isEscrowSelector);

  return isEscrow ? <Escrow description={<EscrowDescriptionContainer />} houses={<EscrowHousesContainer />} /> : null;
};

EscrowContainer.displaName = 'EscrowContainer';
